module.exports = __webpack_public_path__ + "assets/img/1.1359f1c7.png";